// Import the functions you need from the SDKs you need
// import { getDatabase } from 'firebase/database';
import { initializeApp } from "firebase/app";
// import firebase from "firebase";

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

// const firebaseConfig = {
//   apiKey: "AIzaSyAFMBYDSn4cknwBaLb4q7Rks7WjN7dvzLE",

//   authDomain: "timetable-1dcba.firebaseapp.com",

//   databaseURL: "https://timetable-1dcba-default-rtdb.firebaseio.com",

//   projectId: "timetable-1dcba",

//   storageBucket: "timetable-1dcba.appspot.com",

//   messagingSenderId: "591399065060",

//   appId: "1:591399065060:web:1afd7a7b1c938883e5e3f1",
// };
const firebaseConfig = {
  apiKey: "AIzaSyCoE7DeNWo_i3STRw2vD-Auz2CNz8S4e34",
  authDomain: "esp32-firebase-test-78ff0.firebaseapp.com",
  databaseURL: "https://esp32-firebase-test-78ff0-default-rtdb.firebaseio.com",
  projectId: "esp32-firebase-test-78ff0",
  storageBucket: "esp32-firebase-test-78ff0.appspot.com",
  messagingSenderId: "120214192878",
  appId: "1:120214192878:web:48477c682418b704d5e9ff",
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
// const db = getDatabase(app);
// firebase.initializeApp(firebaseConfig);

export default app;
